//@flow

import React from 'react';
import capitalize from 'lodash/capitalize';

import type { SidetripData } from './../../types/cards';
import { HGCardBase, CardBodyTop, CardBodyBottom } from './Common';
import AddBtnMobile from './Common/AddBtnMobile';

type Props = {
  handleCardClick: Function,
  editable: Object,
  cardData: SidetripData,
};

export default function SidetripCard(props: Props) {
  const { handleCardClick, editable, cardData } = props;
  const { name, altitude, duration, address } = cardData;

  return (
    <HGCardBase
      className="sidetripCard"
      editable={editable}
      cardData={cardData}
      onClick={handleCardClick}
    >
      <CardBodyTop title={name ? name : ''} onClick={handleCardClick} type="sidetrip">
        <div className="location">
          <p>{address && capitalize(address)}</p>
        </div>
        <AddBtnMobile editable={editable} cardData={cardData} />
      </CardBodyTop>
      <CardBodyBottom>
        <ul>
          {altitude && (
            <li>
              <span>Altitude: </span>
              {Number(altitude.meters).toLocaleString()} m
            </li>
          )}
          {duration && (
            <li>
              <span>No. of Hours: </span> {duration}
            </li>
          )}
        </ul>
      </CardBodyBottom>
    </HGCardBase>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/SidetripCard.jsx